import removeExoPrefixIfNeeded from './removeExoPrefixIfNeeded';
import safeGetPathname from './safeGetPathname';
export default ((currentProject, productIdToUse) => {
  var _currentProject$produ, _product$tools;
  const pathname = removeExoPrefixIfNeeded(window.location.pathname);
  const product = currentProject === null || currentProject === void 0 ? void 0 : (_currentProject$produ = currentProject.products) === null || _currentProject$produ === void 0 ? void 0 : _currentProject$produ.find(p => p.key === productIdToUse);
  const tool = product === null || product === void 0 ? void 0 : (_product$tools = product.tools) === null || _product$tools === void 0 ? void 0 : _product$tools.find(t => t.url && pathname.startsWith(safeGetPathname(t.url)));
  return tool === null || tool === void 0 ? void 0 : tool.key;
});
//# sourceMappingURL=getCurrentToolId.js.map